import React from 'react';
import ReactPlayer, { FilePlayerProps } from 'react-player/file';
import cm from 'classnames';

import styles from './_player.module.scss';
import { usePlayerPlay } from './use-player-play';
import { usePlayerInit } from './use-player-init';

interface Props extends FilePlayerProps {
  url?: Url;
  playing?: boolean;
  className?: string;
  onInitPlayer?: (init: boolean) => void;
}

const Player = React.forwardRef<ReactPlayer, Props>(
  ({ playing, className, url, onInitPlayer, ...rest }: Props, ref) => {
    const { src, listenUrl, setInitPlayer } = usePlayerInit(url, onInitPlayer);
    usePlayerPlay(ref as React.MutableRefObject<ReactPlayer>, playing);

    return (
      <div className={cm(styles.Player, { [styles['Player--hidden']]: listenUrl }, className)}>
        <ReactPlayer
          width="100%"
          height="100%"
          ref={ref}
          url={src}
          {...rest}
          onReady={(player) => {
            setInitPlayer(true);
            if (rest.onReady) rest.onReady(player);
          }}
        />
      </div>
    );
  }
);

Player.displayName = 'Player';
export { Player, ReactPlayer };
